import { useQuery, useQueryClient } from "react-query";
import { useRouter } from "../../useRouter";
import { useApiError } from "src/hooks/useApiError";
import { getCashUserStatus, getUnregisterBill } from "src/service/pay";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";

interface IUseCheckProductAvailableProps {
  onSuccess?: () => void;
  onError?: () => void;
}
export function useGetCashStatus({
  onSuccess,
  onError,
}: IUseCheckProductAvailableProps) {
  const { handleError } = useApiError();
  const { goConsole, goSiteType, reload } = useRouter();
  const [userInfo] = useRecoilState(userInfoAtom);
  const queryClient = useQueryClient();
  // 내가 구매한 요금제 정보
  const {
    isLoading: userCashStatusLoading,
    data: userCashStatus,
    refetch: userCashStatusRefetch,
  } = useQuery(
    ["getCashStatus", getProductFromSessionStorage()],
    async () =>
      await getCashUserStatus({
        product: [getProductFromSessionStorage()],
      }),
    {
      enabled: userInfo?.loginType !== "",
      refetchOnMount: true, // 컴포넌트가 마운트될 때마다 쿼리를 리페치할지 여부를 나타내는 플래그
      refetchOnWindowFocus: true, // 윈도우가 포커스를 받을 때마다 쿼리를 리페치할지 여부를 나타내는 플래그
      keepPreviousData: false,
      onSuccess: onSuccess
        ? onSuccess
        : async (res) => {
            if (res.status === "REJECT") {
              // 수금확인 거절 시 요금제 선택화면으로 이동
              goSiteType();
            } else if (res.status === "DONE") {
              // if (window.location.pathname.includes("/site/console")) {
              //   await getUnregisterBill({
              //     billType: "PAY",
              //     product: getProductFromSessionStorage(),
              //   }).then((res) => {
              //     if (res?.length > 0) {
              //       reload();
              //     }
              //   });
              // } else {

              goConsole();

              // }
              // queryClient.clear();
              // queryClient.fetchInfiniteQuery("getMyServiceList");
              // queryClient.fetchInfiniteQuery("getPayUnregisterBill");
              // queryClient.fetchInfiniteQuery("getPayUnregisterBill");
              // window.location.href = "/console";
              // reload();
            }
          },
      onError: onError ? onError : handleError,
    }
  );

  return { userCashStatusLoading, userCashStatus, userCashStatusRefetch };
}
